// extracted by mini-css-extract-plugin
export var btn = "Pagination-module--btn--+lMbv";
export var btnNext = "Pagination-module--btnNext--fEW-n";
export var btnPrev = "Pagination-module--btnPrev--11iKv";
export var pagination = "Pagination-module--pagination--K-OlH";
export var paginationLocation = "Pagination-module--pagination-location--7z+oG";